import React, { useEffect, useState } from 'react';
import { Filter, Loading, maxLength, minLength, SearchInput, SelectInput, useNotify ,DateInput,AutocompleteInput} from 'react-admin';
import { fetchCampagne,typeCampagne,json } from '../references';

const FiltreReception =props=> {
    const [listCamps, setListCamps] = useState();
    const {type}=props;
    const notify = useNotify();

    useEffect(() => {
        fetch(process.env.REACT_APP_URL+'/camp/getCampagneForFilters?resource='+type, 
        { method: 'GET',
        headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json;charset=UTF-8',
                "Authorization": "Bearer "+ localStorage.getItem('token')
        }
    }
        ).then(json)
        .then((data) => {
            if(data && data.status>310 && data.error){
                notify(data.error+' : '+data.message,'error');
            } else {
                setListCamps(data);
            }
        }).catch((e) => {
            notify("Erreur lors de la récuperation des campagnes pour le filtre !", 'warning')
        });
    }, []);

    const campTypeChange=(event)=>{
        fetchCampagne(event.target.value,setListCamps,notify);
    }

    if(!listCamps) return <Loading/>

    return (
        <Filter {...props} >
            <SearchInput source="code" alwaysOn  validate={maxLength(8)}/>
            <SelectInput
                source='camp_type'
                label="Type campagne" 
                choices={typeCampagne}
                alwaysOn
                onChange={campTypeChange}
            />
            <AutocompleteInput
                source="camp_id"
                label="Campagne" 
                choices={listCamps}
                allowEmpty={false}
            />
             <SelectInput
                source='status'
                label="Status" 
                choices={[
                    { id: 'recu', name: 'Reçu' },
                    { id: 'non_recu', name: 'Non reçu' }
                ]}
            />
            <DateInput source="start_date" label="Date début"  />
            <DateInput source="end_date" label="Date fin"   />
        </Filter>
    );

    
}

export default FiltreReception;